"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewAnalyticsId = exports.getViewClass = void 0;
const store_1 = require("../../exports/store");
const dom_id_1 = require("../../config/dom_id");
const calendar_view_1 = require("./calendar_view");
const form_view_1 = require("./form_view");
const gallery_view_1 = require("./gallery_view");
const grid_view_1 = require("./grid_view");
const kanban_view_1 = require("./kanban_view");
const gantt_view_1 = require("./gantt_view");
const not_support_view_1 = require("./not_support_view");
const views_1 = require("./views");
const org_chart_view_1 = require("./org_chart_view");
__exportStar(require("./org_chart_view"), exports);
__exportStar(require("./calendar_view"), exports);
__exportStar(require("./form_view"), exports);
__exportStar(require("./gallery_view"), exports);
__exportStar(require("./grid_view"), exports);
__exportStar(require("./kanban_view"), exports);
__exportStar(require("./gantt_view"), exports);
__exportStar(require("./not_support_view"), exports);
__exportStar(require("./views"), exports);
views_1.View.bindModel = (viewType) => {
    const viewClass = getViewClass(viewType);
    return new viewClass();
};
function getViewClass(viewType) {
    switch (viewType) {
        case store_1.ViewType.Kanban:
            return kanban_view_1.KanbanView;
        case store_1.ViewType.Gallery:
            return gallery_view_1.GalleryView;
        case store_1.ViewType.Grid:
            return grid_view_1.GridView;
        case store_1.ViewType.Form:
            return form_view_1.FormView;
        case store_1.ViewType.Calendar:
            return calendar_view_1.CalendarView;
        case store_1.ViewType.Gantt:
            return gantt_view_1.GanttView;
        case store_1.ViewType.OrgChart:
            return org_chart_view_1.OrgChartView;
        default:
            return not_support_view_1.NotSupportView;
    }
}
exports.getViewClass = getViewClass;
// sensor custom attributes 
function getViewAnalyticsId(viewType) {
    switch (viewType) {
        case store_1.ViewType.Kanban:
            return dom_id_1.DATASHEET_ID.VIEW_CREATOR_KANBAN;
        case store_1.ViewType.Gallery:
            return dom_id_1.DATASHEET_ID.VIEW_CREATOR_GALLERY;
        case store_1.ViewType.Grid:
            return dom_id_1.DATASHEET_ID.VIEW_CREATOR_GRID;
        case store_1.ViewType.Form:
            return dom_id_1.DATASHEET_ID.VIEW_CREATOR_FORM;
        case store_1.ViewType.Calendar:
            return dom_id_1.DATASHEET_ID.VIEW_CREATOR_CALENDAR;
        case store_1.ViewType.Gantt:
            return dom_id_1.DATASHEET_ID.VIEW_CREATOR_GANTT;
        case store_1.ViewType.OrgChart:
            return dom_id_1.DATASHEET_ID.VIEW_CREATOR_ORG_CHART;
        default:
            return '';
    }
}
exports.getViewAnalyticsId = getViewAnalyticsId;
//# sourceMappingURL=index.js.map